import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'samplicity-display-translation, [samplicity-display-translation]',
  templateUrl: './display-translation.component.html',
  styleUrls: ['./display-translation.component.scss']
})
export class DisplayTranslationComponent implements OnInit {

  @Input() values: object[];
  get currentLanguage(): string {
    const fullLang = this.locale.getLocale().language;
    const baseLang = fullLang.split('-')[0]; 
    return baseLang;
  }

  constructor(
    public locale: L10nTranslationService
  ) { }

  ngOnInit() {
  }

}
